import React, { useState } from "react";
import { Link } from "react-router-dom";

import "../css/comment-list.css";

import CommentShortInfo from "./CommentShortInfo";

/*
  Элемент списка комментариев
*/
export default function CommentListItem(props) {
  const comment = props.comment

  return (
    <Link to={`/comments/${comment.id}`} className="comment-list-item">
      <CommentShortInfo comment={comment} />
    </Link>
  )
}
